import { useUserSettings } from "@next-platform/client-common-core";
import { CharacterType } from "@next-platform/packages-ts-types";
import { ROUTES } from "@src/constants/navigation";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Spinner, Text } from "@/components/customComponents";
import SearchClientCharacterListing from "@/components/search/SearchClientCharacterListing";
import Trans from "@/components/Trans/Trans";
import { default as useFavoritesTabs, FavoritesTab } from "@/pages/Favorites/useFavoritesTabs";

const FavoritesGroups = () => {
  const { likedBots } = useUserSettings();
  const navigate = useNavigate();
  const { tabItems, onTabChange, hasGroupChat, isGroupChatFlagLoading } = useFavoritesTabs();

  useEffect(() => {
    if (!isGroupChatFlagLoading && !hasGroupChat) {
      navigate(ROUTES.favoriteBots, { replace: true });
    }
  }, [hasGroupChat, isGroupChatFlagLoading, navigate]);

  return (
    <>
      <Text h1 className="m-0 px-4 max-mob:px-2" variant="xxl">
        <Trans i18nKey="chatbot:page.favorites.title.groups" />
      </Text>
      {isGroupChatFlagLoading || !hasGroupChat ? (
        <Spinner centerToScreen={true} />
      ) : (
        <SearchClientCharacterListing
          useStoreTagFilters={false}
          charactersList={likedBots}
          characterType={CharacterType.META}
          tabItems={tabItems}
          activeTab={FavoritesTab.GROUPS}
          onTabChange={onTabChange}
        />
      )}
    </>
  );
};

export default FavoritesGroups;
